import React from 'react'
import Breadcrumb from '../../../components/breadcrumb/breadcrumb'
import Hero from '../../../components/hero-v2/hero'
import TabsCustomLinks from '../../../components/tabsCustomLinks/tabsCustomLinks'
import Layout from '../../../components/layouts/layout'
// import { Question } from '../../../svg/question'
import { Balloon } from '../../../svg/balloon'
import { Muscle } from '../../../svg/muscle'
import { Report } from '../../../svg/report'
import { Medal } from '../../../svg/medal'

const Container = props => {
  const titlesBreadcrumb = {
    titleFinal: 'Sostenibilidad'
  }

  const menu = [
    {
      index: 0,
      hash: '/sobre-prima-afp/responsabilidad-social/gestion-responsable-con-el-medio-ambiente',
      title: 'Medio ambiente',
      icon: Balloon,
    },
    {
      index: 1,
      hash: '/sobre-prima-afp/responsabilidad-social/voluntariado-de-prima-afp',
      title: 'Voluntariado Prima',
      icon: Muscle,
    },
    {
      index: 2,
      hash: '/sobre-prima-afp/responsabilidad-social/reporte-de-sostenibilidad',
      title: 'Reporte de sostenibilidad',
      icon: Report,
    },
    {
      index: 3,
      hash: '/sobre-prima-afp/responsabilidad-social/premio-excelencia-prima-afp',
      title: 'Premiaciones Prima',
      icon: Medal,
    }
  ]

  return (
    <Layout>
     <Hero
        title='Sostenibilidad'
        description='Conoce más sobre nuestras acciones responsables'
        image={'sobre-prima-afp/responsabilidad-social/banner-responsabilidad-social-desktop.svg'}
        imageClassName={'tw-mr-20@lg'}
        imageMobile={'sobre-prima-afp/responsabilidad-social/banner-responsabilidad-social-mobile.svg'}
        linkLabel='Ver nuestros reportes'
        link={'/sobre-prima-afp/responsabilidad-social/reporte-de-sostenibilidad'}
        className={'bg-turquoise-1'}
      />

      <Breadcrumb titlesBreadcrumb={titlesBreadcrumb} />

      <section className='tw-pt-8 tw-pt-10@lg center'>
        <div className={'containerWrap'}>
          <div className='c-gray--4 tw-mb-1'>
            <h2 className='font-family-secondary fw-7 tw-f-24 tw-f-24@lg'>
              Nuestras iniciativas
            </h2>
          </div>
        </div>
      </section>      

      <section className="tw-pt-6 tw-pt-8@lg">
        <TabsCustomLinks data={menu} active={props.active} />
        {props.children}
      </section>
    </Layout>
  )
}

export default Container
